import { SET_EQUIPMENTS_BY_INSURER } from '../actions/equipment'

const defaultState = {
  list: null,
}

const equipmentReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_EQUIPMENTS_BY_INSURER: {
      const { data } = action

      return {
        ...state,
        list: data,
      }
    }
    default:
      return state
  }
}

export default equipmentReducer
